import React, { useEffect, useState } from "react";
import {
    getSchedulerConfig,
    updateSchedulerDelay,
    toggleScheduler,
} from "../services/schedulerApi";
import "./smsForm.css";
import "./SchedulerControl.css";

const SchedulerControl = () => {
    const [delay, setDelay] = useState(1000);
    const [active, setActive] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const loadConfig = async () => {
        try {
            const res = await getSchedulerConfig();
            setDelay(res.data.delay_ms);
            setActive(res.data.active);
        } catch (err) {
            console.error(err);
            setError("Failed to load config");
        }
    };

    useEffect(() => {
        loadConfig();
    }, []);

    const handleUpdate = async () => {
        try {
            setLoading(true);
            setError("");
            setSuccess("");

            await updateSchedulerDelay(delay);
            await toggleScheduler(active);

            setSuccess("Scheduler updated successfully");
        } catch (err) {
            console.error(err);

            const message =
                err.response?.data?.message ||
                err.response?.data ||
                err.message ||
                "Error updating scheduler";

            setError(typeof message === "string" ? message : JSON.stringify(message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page">

            {/* HEADER */}
            <div className="header-card">
                <h2>⏱️ Scheduler Control</h2>
                <p>Configure the SMS scheduler delay and active status</p>
            </div>

            {/* FORM CARD */}
            <div className="card scheduler-card">

                {error && <div className="alert error">{error}</div>}
                {success && <div className="alert success">{success}</div>}

                <div className="form-group">
                    <label>Delay (ms)</label>
                    <input
                        type="number"
                        value={delay}
                        onChange={(e) => setDelay(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Status</label>
                    <div className="toggle-row">
                        <button
                            type="button"
                            className={`toggle-btn ${active === 1 ? "on active" : ""}`}
                            onClick={() => setActive(1)}
                        >
                            ON
                        </button>
                        <button
                            type="button"
                            className={`toggle-btn ${active === 0 ? "off active" : ""}`}
                            onClick={() => setActive(0)}
                        >
                            OFF
                        </button>
                    </div>
                </div>

                <div className="button-group">
                    <button
                        className="button save"
                        onClick={handleUpdate}
                        disabled={loading}
                    >
                        {loading ? "Updating..." : "Save Settings"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SchedulerControl;